import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import {
  NavController,
  NavParams,
  LoadingController,
  ModalController,
  ToastController,
  IonicModule,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";
import { ImagePipe } from "src/app/pipes/image/image";
import { CultoProvider } from "src/app/services/culto/culto";
@Component({
  selector: "app-culto-lista-presenca",
  templateUrl: "./culto-lista-presenca.page.html",
  styleUrls: ["./culto-lista-presenca.page.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, ImagePipe, TranslateModule, LoadingSpinnerComponent],
})
export class CultoListaPresencaPage implements OnInit {
  loaded = false;
  idCulto: string;
  idCultoAgenda: string;
  dataInicio: string;
  liderados: any = [];
  filtro: string;
  public loadingPresenca: { [idPessoa: string]: boolean } = {};

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingController: LoadingController,
    public modalCtrl: ModalController,
    public cultoProvider: CultoProvider,
    private translate: TranslateService,
    private toastCtrl: ToastController
  ) {
    this.idCulto = this.navParams.get("idCulto");
    this.idCultoAgenda = this.navParams.get("id");
    this.dataInicio = this.navParams.get("dataInicio");
    this.loadPresenca();
  }

  ngOnInit() {}

  loadPresenca() {
    this.cultoProvider.getPresencaLiderados(this.idCultoAgenda).subscribe((data) => {
      this.liderados = data;
    });
    setTimeout(() => {
      this.loaded = true;
    }, 1000);
  }

  public closeModal() {
    this.modalCtrl.dismiss(this.idCultoAgenda);
  }

  async changePresenca(presenca: any) {
    const id = presenca.idPessoa;
    this.loadingPresenca[id] = true;

    this.cultoProvider
      .salvarPresenca(this.idCulto, this.dataInicio, this.idCultoAgenda, presenca)
      .subscribe(async (data) => {
        if (!data.error) {
          this.idCultoAgenda = data.idCultoAgenda;
          this.liderados = this.liderados.map((item: { idPessoa: any; presenca: string }) => {
            if (item.idPessoa === presenca.idPessoa) {
              return {
                ...item,
                presenca: item.presenca === "1" ? "0" : "1",
              };
            }
            return item;
          });
          this.showAlert(this.translate.instant("Presença salva com sucesso!"));
        } else {
          this.showAlert(this.translate.instant("Ocorreu um erro ao salvar a presença!"));
        }

        setTimeout(() => {
          this.loadingPresenca[id] = false;
        }, 1000);
      });
  }

  async showAlert(message: string) {
    const toast = await this.toastCtrl.create({
      message: message,
      duration: 3000,
    });
    toast.dismiss();
    toast.present();
  }

  get lideradosFiltrados() {
    const termo = this.filtro?.toLowerCase().trim();
    if (!termo) return this.liderados;

    return this.liderados.filter((p: any) => p.nome?.toLowerCase().includes(termo));
  }
}
